export default __webpack_public_path__ + "static/media/take-off.0c7feb62.svg";